import {Component} from '@angular/core';
import { AuthService } from 'src/app/modules/core/services/auth/auth.service';
import { RoleEnum } from '../../modules/shared/models';
// import { AuthService } from 'src/app/modules/shared/auth.service';
import { environment } from 'src/environments/environment';
import { INavItem } from './navitem.model';
import { IAuthRequestUserDetail } from 'src/app/modules/auth/models/user.model';
import { UI_MESSAGES, UI_ROUTES } from 'src/app/app.contant';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from 'src/app/modules/shared/services/local-storage/local-storage.service';


@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss']
})
export class DefaultLayoutComponent {
  public readonly ROUTES = UI_ROUTES;
  public sidebarMinimized = false;
  public navItems : Array<INavItem> = [
    {
      name : "Dashboard",
      route : "/dashboard",
      icon : "fa-dashcube",
      roleAccess : [RoleEnum.ADMIN, RoleEnum.BUYER, RoleEnum.REPORTING_MANAGER, RoleEnum.REQUESTER, RoleEnum.SUPPLIER]
    },
    {
      name : "PR Initiator",
      route : "/pr-initiator",
      icon : "fa-play-circle",
      roleAccess : [RoleEnum.ADMIN, RoleEnum.REQUESTER]
    },
    {
      name : "Upload",
      route : "/upload",
      icon : "fa-cloud-upload",
      roleAccess : [RoleEnum.ADMIN, RoleEnum.REQUESTER, RoleEnum.BUYER,RoleEnum.EHS_MANAGER]
    },
    {
      name : "Download",
      route : "/test",
      icon : "fa-cloud-download",
      roleAccess : [RoleEnum.ADMIN, RoleEnum.BUYER, RoleEnum.REPORTING_MANAGER, RoleEnum.REQUESTER, RoleEnum.SUPPLIER]
    },
    {
      name : "Send Notification",
      route : "/test",
      icon : "fa-bell-o",
      roleAccess : [RoleEnum.ADMIN, RoleEnum.BUYER, RoleEnum.REPORTING_MANAGER, RoleEnum.REQUESTER, RoleEnum.SUPPLIER]
    },
    {
      name : "PR Process",
      route : "/test",
      icon : "fa-suitcase",
      roleAccess : [RoleEnum.ADMIN, RoleEnum.BUYER]
    },
    {
      name : "RFQ",
      route : "/test",
      icon : "fa-money",
      roleAccess : [RoleEnum.ADMIN, RoleEnum.SUPPLIER]
    }
  ];

  public userDetails : IAuthRequestUserDetail | null;
  public defaultProfile : string = "https://ui-avatars.com/api/?name="
  // "https://s.gravatar.com/avatar/e8c7dc53e162070c50e6ab1b5f1afff7?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fgr.png"
  public userRole : string = "";
  public accessType : string | null;
  public activeTab: string = 'home';
  public homeUrl!: string
  // public toggleMinimize(e : boolean) : void {
  //   this.sidebarMinimized = e;
  // }

  constructor(private _authService : AuthService, private router : Router, private activeRoute: ActivatedRoute,
    private _toastrService : ToastrService, private localStorageService: LocalStorageService) {
    this.userDetails = this._authService.getUserDetails(); // Commenting this out as this is based on Auth0
    const userType = this._authService.getUserRole() as RoleEnum;
    this.userRole = userType;
    this.accessType = this.localStorageService.getAccessModule()
  }

  ngOnInit(){
    console.log(window.location.pathname.includes('dashboard-charts'));
    if(window.location.pathname.includes('dashboard-charts')){
      this.activeTab = 'dashboard';
    }
  }

  public getHomeLink() {
    if (this.userRole.toLocaleLowerCase() == 'supplier') {
      this.homeUrl = '/supplier/dashboard'
    } else if (this.userRole.toLocaleLowerCase() == 'admin') {
      this.homeUrl = '/admin/home'
    } else {
      this.homeUrl = '/dashboard'
    }
    return this.homeUrl
  }

  public logOut() : void {
    this._authService.logout().subscribe((res:any)=>{
      if(res.status === 200){
        this._authService.clearAllStorage();
        this.router.navigate(['/']);
        this._toastrService.success(UI_MESSAGES.LOGOUT);
        if(environment.manualLogin) {
          // this.router.navigate([this.ROUTES.LOGIN]);
          this.router.navigate(['/']);
        } else {
          if(environment.domainURL) location.href=environment.domainURL;
          if(!environment.domainURL) this.router.navigate(['/']);
        }
      }
    });
  }

  public setActiveTab(activeTab:string){
    this.activeTab = activeTab
  }
}
